export default __webpack_public_path__ + "static/media/Privacy-Liability.e9bbece8.png";